import { render, staticRenderFns } from "./AutoFlickity.vue?vue&type=template&id=4c7add44&scoped=true"
import script from "./AutoFlickity.vue?vue&type=script&lang=js"
export * from "./AutoFlickity.vue?vue&type=script&lang=js"
import style0 from "./AutoFlickity.vue?vue&type=style&index=0&id=4c7add44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7add44",
  null
  
)

export default component.exports